import { takeLatest, all, call, put } from 'redux-saga/effects';

import * as endpoints from './endpoint';
import {
  addAsset,
  addAssetSuccess,
  addAssetFailed,
  getAssets,
  getAssetsSuccess,
  getAssetsFailed,
  deleteAsset,
  deleteAssetSuccess,
  deleteAssetFailed,
  updateAsset,
  updateAssetFailed,
  updateAssetSuccess,
  addVendor,
  addVendorFailed,
  addVendorSuccess,
  getVendors,
  getVendorsFailed,
  getVendorsSuccess,
  addRepairAssets,
  addRepairAssetsFailed,
  addRepairAssetsSuccess,
  getAssetDetailsFailed,
  getAssetDetails,
  getAssetDetailsSuccess,
} from './slice';
import { request } from '@app/services';

// ----------------------------------------
function* getAssetSaga(action: ReturnType<typeof getAssets>): any {
  try {
    const result = yield call(request.get, endpoints.assetList);
    yield put(getAssetsSuccess(result.data));
  } catch (err) {
    yield put(getAssetsFailed(err));
  }
}

function* addAssetSaga(action: ReturnType<typeof addAsset>): any {
  try {
    const {
      assetName,
      purchaseDate,
      manufacturer,
      warranty,
      cost,
      serialNumber,
      assetUser,
      condition,
      status,
      model,
      gst,
      supplier,
      description,
      otherAssetName,
      vendor,
      assetsImage,
    } = action.payload;
    const formData = new FormData();
    formData.append('assetName', assetName);
    formData.append('otherAssetName', otherAssetName);
    formData.append('purchaseDate', purchaseDate);
    formData.append('vendorId', vendor);
    if (assetUser) {
      formData.append('assetUser', assetUser);
    }
    formData.append('manufacturer', manufacturer);
    formData.append('warranty', warranty);
    formData.append('cost', cost);
    formData.append('gst', gst);
    formData.append('serialNumber', serialNumber);
    formData.append('condition', condition);
    formData.append('status', status);
    formData.append('model', model);
    formData.append('supplier', supplier);
    formData.append('description', description);
    formData.append('image', assetsImage);

    const result = yield call(request.post, endpoints.addAsset, formData);
    yield put(addAssetSuccess(result.data));
  } catch (err) {
    yield put(addAssetFailed(err));
  }
}
function* addRepairAssetSaga(action: ReturnType<typeof addRepairAssets>): any {
  try {
    const { assetId, repairPart, status, about, cost } = action.payload;
    const result = yield call(request.post, endpoints.addRepair, {
      assetId,
      partName: repairPart,
      status,
      about,
      repairCost: cost,
    });
    yield put(addRepairAssetsSuccess(result.data));
  } catch (err) {
    yield put(addRepairAssetsFailed(err));
  }
}
// ----------------------------------------
function* deleteAssetSaga(action: ReturnType<typeof deleteAsset>): any {
  try {
    const { id } = action.payload;
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const result = yield call(request.delete, `${endpoints.deleteAsset}${id}`);
    yield put(deleteAssetSuccess(result.data));
  } catch (err) {
    yield put(deleteAssetFailed(err));
  }
}
// ----------------------------------------
function* updateAssetSaga(action: ReturnType<typeof updateAsset>): any {
  try {
    const {
      id,
      assetName,
      assetUser,
      purchaseDate,
      manufacturer,
      warranty,
      cost,
      gst,
      serialNumber,
      condition,
      status,
      model,
      supplier,
      description,
      assetsImage,
      otherAssetName,
      vendor,
    } = action.payload;
    const formData = new FormData();
    formData.append('assetName', assetName);
    formData.append('otherAssetName', otherAssetName);
    formData.append('purchaseDate', purchaseDate);
    formData.append('vendorId', vendor);
    formData.append('assetUser', assetUser);
    formData.append('manufacturer', manufacturer);
    formData.append('warranty', warranty);
    formData.append('cost', cost);
    formData.append('gst', gst);
    formData.append('serialNumber', serialNumber);
    formData.append('condition', condition);
    formData.append('status', status);
    formData.append('model', model);
    formData.append('supplier', supplier);
    formData.append('description', description);
    if (typeof assetsImage === 'object') {
      formData.append('image', assetsImage);
    }

    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const result = yield call(request.put, `${endpoints.updateAsset}${id}`, formData);
    yield put(updateAssetSuccess(result.data.data));
    yield put(getAssetDetails(id));
  } catch (err) {
    yield put(updateAssetFailed(err));
  }
}

function* addVendorSaga(action: ReturnType<typeof addVendor>): any {
  try {
    const { name } = action.payload;
    const result = yield call(request.post, endpoints.addVendor, {
      name,
    });
    yield put(addVendorSuccess(result.data));
  } catch (err) {
    yield put(addVendorFailed(err));
  }
}
function* getVendorsSaga(action: ReturnType<typeof getVendors>): any {
  try {
    const query = action.payload;
    const result = yield call(request.get, endpoints.vendors, {
      params: {
        query,
      },
    });
    yield put(getVendorsSuccess(result.data));
  } catch (err) {
    yield put(getVendorsFailed(err));
  }
}
function* getAssetDetailsSaga(action: ReturnType<typeof getAssetDetails>): any {
  try {
    const assestId = action.payload;
    // eslint-disable-next-line @typescript-eslint/no-base-to-string, @typescript-eslint/restrict-template-expressions
    const result = yield call(request.get, `${endpoints.assetDetails}${assestId}`);
    yield put(getAssetDetailsSuccess(result.data));
  } catch (err) {
    yield put(getAssetDetailsFailed(err));
  }
}
function* assetSagas() {
  yield all([
    takeLatest(
      [
        getAssets,
        addAssetSuccess,
        deleteAssetSuccess,
        updateAssetSuccess,
        addVendorSuccess,
        addRepairAssetsSuccess,
      ],
      getAssetSaga
    ),
    takeLatest([getVendors, addVendorSuccess], getVendorsSaga),
    takeLatest(addAsset, addAssetSaga),
    takeLatest(deleteAsset, deleteAssetSaga),
    takeLatest(updateAsset, updateAssetSaga),
    takeLatest(addVendor, addVendorSaga),
    takeLatest(getAssetDetails, getAssetDetailsSaga),
    takeLatest(addRepairAssets, addRepairAssetSaga),
  ]);
}

export { assetSagas };
